// language=GraphQL
export const ALL_CURRENCIES_QUERY = `query Query {
  currencies: systemCurrencies {
    id
    name
    symbol
    code
    isDefault
    exchangeRate
    defaultCountries
  }
}`

// language=GraphQL
export const SINGLE_CURRENCY_QUERY = `query Query($id: ID!) {
  currency: systemCurrency(id: $id) {
    id
    name
    symbol
    code
    isDefault
    exchangeRate
    defaultCountries
  }
}`

// language=GraphQL
export const CREATE_CURRENCY_MUTATION = `
  mutation Mutation($input: CreateSystemCurrencyInput) {
    currency: createSystemCurrency(input: $input) {
      id
      name
      symbol
      code
      isDefault
      exchangeRate
      defaultCountries
    }
  }`

// language=GraphQL
export const UPDATE_CURRENCY_MUTATION = `
  mutation Mutation($input: UpdateSystemCurrencyInput) {
    currency: updateSystemCurrency(input: $input) {
      id
      name
      symbol
      code
      isDefault
      exchangeRate
      defaultCountries
    }
  }`

// language=GraphQL
export const DELETE_CURRENCY_MUTATION = `
  mutation Mutation($input: DeleteSystemCurrencyInput) {
    deleteSystemCurrency(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_CURRENCY_MUTATION = `
  mutation Mutation($input: DeleteSystemCurrencyInput) {
    forceDeleteSystemCurrency(input: $input) {
      success
    }
  }`
// language=GraphQL
export const CURRENCIES_DEPENDENTS_QUERY = `query Query($id: ID!, $withTravelPricingCurrencyOverrides: Boolean = false) {
  groupedDependents: systemCurrencyDependents(id: $id) {
    travelPricingCurrencyOverrides @include(if: $withTravelPricingCurrencyOverrides) {
      id
      enabled
      exchangeRate    }
  }
}`
